// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","icon":"spinner_icon__sRaet","popup_icon_1":"spinner_popup_icon_1__I9MuV","popup_icon_2":"spinner_popup_icon_2__o64yw"};